import React from "react";
import ServiceTop from "../../components/layouts/ServiceTop";

//images
import serviciosAdicion from "../../images/servicios/servicios_adicionales.png";
import secAdicion from "../../images/servicios/sec_adicionales.png";
import { ServiciosAdicionalesU } from "../../utils/itemsToogle";
import BotonContactar from "../../components/layouts/boton/BotonContactar";
import { ToogleDescription } from "../../components/toggleDescComp/ToogleDescription";
export default function ServiciosAdicionales() {
  return (
    <>
      <ServiceTop
        title="Servicios Adicionales."
        image={serviciosAdicion}
        secImage={secAdicion}
        text={`Ofrecemos una amplia gama de servicios que se ajustarán a sus
        necesidades técnicas, económicas y de seguridad.     
        `}
      />
      <ToogleDescription itemsToggle={ServiciosAdicionalesU} />
      <BotonContactar />
    </>
  );
}
